import { BenefitDto } from 'theSource/queries';
import {
  isCoverageDeclined,
  calculateAllocation,
  filterBeneficiaries,
  checkEmptyAllocation,
  checkZeroAllocation,
} from 'enrollment/utils/common/Utils';
import { BeneficiaryTypes } from 'enrollment/features/AddYourBeneficiaries/services';

// copied from theSource/queries/useBenefitCategoryQuery/types/dtos.ts
// updated to work with the BenefitDto type used with the useBenefitsQuery instead of
// the CategoryResponseDto type used with the useBenefitCategoryQuery used by the other
// instance of this method
export const filteredBeneficiaries = (
  benefits: BenefitDto[] | undefined
) => {
  return benefits?.map((benefit: BenefitDto) => {
    if (
      benefit?.coverage &&
      !isCoverageDeclined(benefit?.coverage) &&
      benefit?.beneficiary_required === true
    ) {
      const beneficiaries: BeneficiaryTypes[] =
        benefit?.coverage?.beneficiaries || [];
      const updatedBeneficiaries = benefit?.coverage?.beneficiaries?.map((beneficiary) => {
        if (beneficiary.id) {
          return { ...beneficiary, uniq_id: beneficiary.id };
        }
        return beneficiary;
      });
      return {
        orgBenefitId: benefit?.org_benefit_id,
        orgBenefitName: benefit?.org_benefit_name,
        beneficiaries: updatedBeneficiaries,
        primaryTotalAllocation: calculateAllocation(
          filterBeneficiaries(beneficiaries, true)
        ),
        secondaryTotalAllocation: calculateAllocation(
          filterBeneficiaries(beneficiaries, false)
        ),
        primaryEmptyAllocation: checkEmptyAllocation(
          filterBeneficiaries(beneficiaries, true)
        ),
        secondaryEmptyAllocation: checkEmptyAllocation(
          filterBeneficiaries(beneficiaries, false)
        ),
        primaryZeroAllocation: checkZeroAllocation(
          filterBeneficiaries(beneficiaries, true)
        ),
        secondaryZeroAllocation: checkZeroAllocation(
          filterBeneficiaries(beneficiaries, false)
        ),
        coverageFields: {
          req_volume: benefit?.coverage?.req_volume,
          carrier_logo_url: benefit?.coverage?.carrier_logo_url,
          carrier_name: benefit?.coverage?.carrier_name,
          esign_data: benefit?.coverage?.beneficiary_esign_data,
        },
      };
    }
    return null;
  });
};
